export default __webpack_public_path__ + "static/media/close.a43ed3b1.svg";